export default __webpack_public_path__ + "static/media/my_journey_part2_4.fde1c54f.png";